module.exports = __webpack_public_path__ + "img/chinesecompany76.f9e507b7.png";